import(/* webpackMode: "eager", webpackExports: ["BlogPostContent"] */ "/app/apps/web/src/components/news/blog/BlogPostContent.tsx");
